<component class="vue-label-root" v-bind:is="tag" :for="inputId">{{ text }}<span class="required-asterisk" v-if="required">*</span></component>